// extracted by mini-css-extract-plugin
export default {"contentblockBorder":"ContentBlockBorder_contentblockBorder__kHxn-"};